export default function useCurrency (price: number, currencyCode: string = "", displayDecimalPlaces: number | null = null) {
  const { locale, locales } = useI18n();
  const regionStore = useRegionStore();
  const runtimeConfig = useRuntimeConfig();

  const targetRegion = regionStore.regions.find(item => item.iso2 === (runtimeConfig.public.region as string).toUpperCase() || currencyCode === item.currency);
  const formatOfLocal = locales.value.find(item => item.code === locale.value);
  const formatString = formatOfLocal?.format || regionStore.regions[0].locales;

  return (Intl.NumberFormat(formatString as string, {
    style: "currency",
    currency: targetRegion!.currency,
    minimumFractionDigits: targetRegion!.minimumFractionDigits,
    maximumFractionDigits: displayDecimalPlaces ?? targetRegion!.maximumFractionDigits
  }).format(price));
}
